<div class="image-container" [inlineSVG]='"/static/images/svg/card_dispenser.svg"'>
</div>